import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useLocation, useNavigate } from "react-router-dom";
import NisMasterlistAdd from './nisMasterlistAdd';
import useNisMasterlist from '../Hooks/NisMasterlistHooks/useNisMasterlist';
import useDeleteNISfsResult from '../Hooks/NisFsResultHooks/useDeleteNisfsResult';
import adminBg from '../Assets/bg/adminbg.jpg';
import Loader from '../Components/Loader';
import DeleteConfirmationModal from '../Components/DeleteConfirmationModal';
import ExcelJS from 'exceljs';

const NisMasterlist = ({ darkMode, year, onBack, onSelect, nisId, iaName, isName }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [showEditPanel, setShowEditPanel] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedYear, setSelectedYear] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  // NIS context received from the NIS modal: filter masterlist to a specific IA / IS.
  // Accept it from props (DashboardAdmin) or from location.state (router-based callers).
  const nisIdFromState = nisId ?? location.state?.nisId ?? null;
  const iaNameFromState = iaName ?? location.state?.iaName ?? null;
  const isNameFromState = isName ?? location.state?.isName ?? null;
  console.log("NISmasterlist received year:", year, "nisId:", nisIdFromState, "iaName:", iaNameFromState, "isName:", isNameFromState);
  const { data, loading, error, refetch } = useNisMasterlist(year, iaNameFromState, isNameFromState);
  const normalizeName = (value) => (value || '').toString().trim().toLowerCase();

  const [isSidebarExpanded] = useState(false);
  const [showRightPanel, setShowRightPanel] = useState(false);
  const [showAllData, setShowAllData] = useState(false);
  const { deleteNISfsResult } = useDeleteNISfsResult();
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [headerTitle, setHeaderTitle] = useState(localStorage.getItem('nisFsResult_headerTitle') || 'NIS -  MASTERLIST ');
  const [headerDate, setHeaderDate] = useState(localStorage.getItem('nisFsResult_headerDate') || `BOHOL INTEGRATED IRRIGATION SYSTEM, ${selectedYear || '2025'}`);
  const [headerProvince, setHeaderProvince] = useState(localStorage.getItem('nisMasterlist_headerProvince') || 'CY 2024');
  const [isEditingHeader, setIsEditingHeader] = useState(false);
  const [addSuccessMessage, setAddSuccessMessage] = useState(null)

  const saveHeader = () => {
    localStorage.setItem('nisMasterlist_headerTitle', headerTitle);
    localStorage.setItem('nisMasterlistt_headerDate', headerDate);
    localStorage.setItem('nisMasterlist_headerProvince', headerProvince);
    setIsEditingHeader(false);
  };

  const handleAddSuccess = (msg) => {
    setAddSuccessMessage(msg || 'NIS data successfully added!');
    setTimeout(() => setAddSuccessMessage(null), 3000);
    // Force refetch after adding data
    if (refetch) refetch();
  };

console.log("Received year from location.state:", location.state?.year);


  useEffect(() => {
  // Use year from location.state if available
  if (location.state?.year) {
    setSelectedYear(location.state.year);
    setHeaderDate(`BOHOL INTEGRATED IRRIGATION SYSTEM, ${location.state.year}`);
    return;
  }

}, [location.state?.year]);


  useEffect(() => {
    if (selectedYear && refetch) {
      console.log('Refetching data for year:', selectedYear);
      refetch();
    }
  }, [selectedYear, refetch]);

   useEffect(() => {
    console.log('Raw data from useNisMasterlist hook:', data);
  }, [data]);
  
  useEffect(() => {
    const scrollContent = document.getElementById('scrollContent');
    const bottomScroll = document.getElementById('bottomScroll');

    if (scrollContent && bottomScroll) {
      const onBottomScroll = () => {
        scrollContent.scrollLeft = bottomScroll.scrollLeft;
      };

      const onContentScroll = () => {
        bottomScroll.scrollLeft = scrollContent.scrollLeft;
      };

      bottomScroll.addEventListener('scroll', onBottomScroll);
      scrollContent.addEventListener('scroll', onContentScroll);

      return () => {
        bottomScroll.removeEventListener('scroll', onBottomScroll);
        scrollContent.removeEventListener('scroll', onContentScroll);
      };
    }
  }, []);

  const handleClose = () => {
    setShowRightPanel(false);
    console.log('Form closed');
  };

  const handleRowClick = (item) => {
    setSelectedItem(item);
  };

  const handleEditData = (item) => {
    console.log('Editing IA ID:', item.id);
    setSelectedItem(item);
    setShowEditPanel(true);
  };

  const closeEditPanel = () => {
    setShowEditPanel(false);
    setSelectedItem(null);
  };

  const handleDeleteClick = (item) => {
    setConfirmDelete(item);
  };

  const handleBack = () => {
    if (typeof onBack === 'function') {
      onBack();
      return;
    }

    if (typeof onSelect === 'function') {
      onSelect('NIS');
      return;
    }

    navigate(-1);
  };

  const allFlattenedData = data
    ? data.flatMap(isItem =>
        (isItem.ias || []).flatMap(ia =>
          (ia.rows || []).map(row => ({
            ...row,
            id: row.id,
            ia_name: ia.ia_name,
            is_name: isItem.is_name,
            createdAt: row.createdAt || isItem.createdAt || ia.createdAt
          }))
        )
      ).sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
    : [];

  // If we arrived from the NIS modal, narrow the masterlist to that specific NIS row
  // (linked by ia_name and/or is_name; the nis_masterlist table has no nis_id column).
  const flattenedData = (iaNameFromState || isNameFromState)
    ? allFlattenedData.filter(item =>
        (!iaNameFromState || normalizeName(item.ia_name) === normalizeName(iaNameFromState)) &&
        (!isNameFromState || normalizeName(item.is_name) === normalizeName(isNameFromState))
      )
    : allFlattenedData;

  console.log('Flattened Data:', flattenedData);

  const filteredData = flattenedData.filter(item =>
    Object.values(item).some(val =>
      (val?.toString()?.toLowerCase() || '').includes(searchQuery.toLowerCase())
    )
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, year, iaNameFromState, isNameFromState]);

  const isOrder = [...new Set(flattenedData.map(item => item.is_name))];

  const totalPages = Math.max(1, Math.ceil(filteredData.length / rowsPerPage));
  const safeCurrentPage = Math.min(currentPage, totalPages);
  const pageStart = (safeCurrentPage - 1) * rowsPerPage;
  const pageEnd = pageStart + rowsPerPage;
  const paginatedData = filteredData.slice(pageStart, pageEnd);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  const uniqueISGroups = Object.entries(
    paginatedData.reduce((acc, item) => {
      const group = item.is_name || 'Unknown';
      if (!acc[group]) acc[group] = { items: [] };
      acc[group].items.push(item);
      return acc;
    }, {})
  ).sort(([a], [b]) => isOrder.indexOf(a) - isOrder.indexOf(b));

  const displayedGroups = uniqueISGroups;

  const shouldShowPagination = filteredData.length > rowsPerPage;

  const handlePreviousPage = () => {
    setCurrentPage((prev) => Math.max(1, prev - 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(totalPages, prev + 1));
  };

 const handleExport = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('NisFsResult');

    worksheet.mergeCells('A1:Q1');
    const titleCell = worksheet.getCell('A1');
    titleCell.value = headerTitle;
    titleCell.font = { name: 'Calibri', size: 18, bold: true };
    titleCell.alignment = { horizontal: 'left', vertical: 'middle' };

    worksheet.mergeCells('A2:Q2');
    worksheet.getCell('A2').value = headerDate;
    worksheet.getCell('A2').font = { name: 'Calibri', size: 18 };

    worksheet.mergeCells('A3:Q3');
    worksheet.getCell('A3').value = headerProvince;
    worksheet.getCell('A3').font = { name: 'Calibri', size: 18 };

    worksheet.addRow([]);
 const mainHeaders = [
      'ACTIONS', 'NO', 'NAME OF SYSTEM', 'TYPE OF SYSTEM', 'NAME OF IA', 'REGION ia',
      'PROVINCE ia', 'MUNICIPALITY ia', 'BARANGAY ia', 'LAST NAME', 'FIRST NAME',
      'MIDDLE NAME', 'EXTENSION NAME', 'SEX (M/F)', 'BIRTHDAY', 'MOTHERS MAIDEN NAME', 
      'SPOUSE LASTNAME', 'SPOUSE FIRSTNAME', 'SPOUSE MIDDLENAME',  'SPOUSE EXT NAME',  
      'REGION', 'PROVINCE', 'MUNICIPALITY',  'BARANGAY', 'HOUSE NUMBER/ STREET/ PUROK', 'REGIONfarm',
      'REGIONfarm',  'PROVINCEfarm',  'MUNICIPALITYfarm',  'BARANGAYfarm',  'FARM LOT NO.', 'FARM LOT CODE', 'FARM AREA (Ha)',
      'TYPE OF OWNERSHIP', 'RSBSA REGISTERED? (Y/N)', 'WITH DA IMC? (Y/N)', 'IF YES, RSBSA REFERENCE NO.? (00-00-00-000-000000)',
      'IF NONE, RSBSA STUB CONTROL NUMBER? (00-00-00-000-000000) /n or type LOST, if RSBSA Enrollment Stub was los', 
      'WITH NATIONAL ID? (Y/N)',  'IF YES, PHILSYS CARD NUMBER?', 'IF NONE, TRANSACTION SLIP NO.',
    ];

    const mainHeaderRow = worksheet.addRow(mainHeaders);

    mainHeaderRow.eachCell((cell, colNumber) => {
      cell.font = { size: 12, bold: true, color: { argb: 'FFFFFFFF' } };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '2E7D32' } };
      cell.alignment = { horizontal: 'center', wrapText: true };
      cell.border = {
        top: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } },
      };
      if (colNumber === 10) {
        worksheet.mergeCells(`J${mainHeaderRow.number}:K${mainHeaderRow.number}`);
        cell.alignment = { horizontal: 'center', wrapText: true };
      }
      if (colNumber === 13) {
        worksheet.mergeCells(`M${mainHeaderRow.number}:N${mainHeaderRow.number}`);
        cell.alignment = { horizontal: 'center', wrapText: true };
      }
    });

    const subHeaders = [
      '', '', '',  '1', '2',  '3',  'R',  
      '1', '2',  '3', '4',  '5',  '6',  '7', '8', 'R','',
       'POT\'L', 'ACTUAL', '', '', '', ''
    ];
    const subHeaderRow = worksheet.addRow(subHeaders);

    subHeaderRow.eachCell((cell, colNumber) => {
      cell.font = { size: 12, bold: true, color: { argb: 'FFFFFFFF' } };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '4CAF50' } };
      cell.alignment = { horizontal: 'center', wrapText: true };
      cell.border = {
        top: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } },
      };
      if (colNumber === 15) {
        worksheet.mergeCells(`O${subHeaderRow.number}:Q${subHeaderRow.number}`);
      }
    });

    const exportGroups = Object.entries(
      filteredData.reduce((acc, item) => {
        const group = item.is_name || 'Unknown';
        if (!acc[group]) acc[group] = { items: [] };
        acc[group].items.push(item);
        return acc;
      }, {})
    ).sort(([a], [b]) => isOrder.indexOf(a) - isOrder.indexOf(b));

    let rowIndex = 1;
    exportGroups.forEach(([is_name, group]) => {
      const groupRow = worksheet.addRow([is_name.toUpperCase()]);
      worksheet.mergeCells(`A${groupRow.number}:Q${groupRow.number}`);
      groupRow.eachCell(cell => {
        cell.font = { size: 12, bold: true };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'CADABA' } };
        cell.alignment = { horizontal: 'left', vertical: 'middle' };
        cell.border = {
          top: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } },
        };
      });

      group.items.forEach((item) => {
        const row = worksheet.addRow([
          rowIndex++,
          item.system_name,
          item.system_type,
          item.ia_name,
          item.ia_region,
          item.ia_province,
          item.ia_municipality,
          item.ia_barangay,
          item.lastname,
          item.firstname,
          item.ia_tin,
          item.middlename,
          item.extensionName,
          item.sex,
          item.birthday,
          item.mothers_maidenName,
          item.spouse_lastname,
          item.spouse_firstName || item.spouse_firstname,
          item.spouse_middleName || item.spouse_middlename,
          item.spouse_extName,
          item.region,
          item.province,
          item.municipality,
          item.barangay,
          item.houseNumber,
          item.regionFarm,
          item.provinceFarm,
          item.municipalityFarm,
          item.barangayFarm,
          item.farm_lotNum,
          item.farm_lotCode,
          item.farmArea,
          item.ownershipType,
          item.rsbsa_registered,
          item.da_imc,
          item.rsbsa_refNum,
          item.rsbsa_controlNum,
          item.national_id,
          item.philsys_cardNum,
          item.transactionSlip
        ]);


        row.eachCell((cell, colNumber) => {
          cell.font = { size: 12 };
          cell.border = {
            top: { style: 'thin', color: { argb: '000000' } },
            bottom: { style: 'thin', color: { argb: '000000' } },
            left: { style: 'thin', color: { argb: '000000' } },
            right: { style: 'thin', color: { argb: '000000' } },
          };
          if ([3, 4, 6, 7].includes(colNumber)) {
            cell.alignment = { horizontal: 'left', vertical: 'top', wrapText: true };
          } else if ([14, 15, 16, 17].includes(colNumber)) {
            cell.alignment = { horizontal: 'right', vertical: 'top', wrapText: true };
          } else {
            cell.alignment = { horizontal: 'center', vertical: 'top', wrapText: true };
          }
        });
      });
    });

    worksheet.columns = [
      { key: 'actions', width: 10 }, // Placeholder for ACTIONS
      { key: 'no', width: 5 },
      { key: 'system_type', width: 30 },
      { key: 'ia_name', width: 30 },
      { key: 'ia_region', width: 10 },
      { key: 'ia_province', width: 25 },
      { key: 'ia_municipality', width: 25 },
      { key: 'ia_barangay', width: 25 },
      { key: 'lastname', width: 15 },
      { key: 'firstname', width: 15 },
      { key: 'middlename', width: 10 },
      { key: 'extensionName', width: 15 },
      { key: 'sex', width: 10 },
      { key: 'birthday', width: 10 },
      { key: 'mothers_maidenName', width: 15 },
      { key: 'spouse_lastname', width: 10 },
      { key: 'spouse_firstName', width: 15 },
      { key: 'spouse_middleName', width: 15 },
      { key: 'spouse_extName', width: 15 },
       { key: 'region', width: 15 },
       { key: 'province', width: 15 },
       { key: 'municipality', width: 15 },
       { key: 'barangay', width: 15 },
      { key: 'houseNumber', width: 15 },
      { key: 'regionFarm', width: 15 },
      { key: 'provinceFarm', width: 15 },
      { key: 'municipalityFarm', width: 15 },
      { key: 'barangayFarm', width: 15 },
      { key: 'farm_lotNum', width: 15 },
      { key: 'farm_lotCode', width: 15 },
      { key: 'farmArea', width: 15 },
       { key: 'ownershipType', width: 15 },
        { key: 'rsbsa_registered', width: 15 },
        { key: 'da_imc', width: 15 },
        { key: 'rsbsa_refNum', width: 15 },
        { key: 'rsbsa_controlNum', width: 15 },
        { key: 'national_id', width: 15 },
        { key: 'philsys_cardNum', width: 15 },
        { key: 'transactionSlip', width: 15 },
    ];


    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    if (window.isSecureContext && 'showSaveFilePicker' in window) {
      try {
        const options = {
          suggestedName: `FS_Masterlist_BIIS_${selectedYear || '2025'}.xlsx`,
          types: [{
            description: 'Excel File',
            accept: {
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
            }
          }]
        };
        const handle = await window.showSaveFilePicker(options);
        const writable = await handle.createWritable();
        await writable.write(blob);
        await writable.close();
      } catch (err) {
        console.error('Error saving file:', err.name, err.message || err);
        if (err.name !== 'AbortError') {
          alert('Save failed due to an unexpected error. Check the console.');
        }
      }
    } else {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `FS_Masterlist_BIIS_${selectedYear || '2025'}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: darkMode ? 'black' : 'white',
      }}>
        <Loader />
      </div>
    );
  }

  if (error) {
    return <div>Error: { error}</div>;
  }


  return (
    <>
      {addSuccessMessage && (
        <div
          style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            backgroundColor: '#4caf50',
            color: '#fff',
            padding: '10px 20px',
            borderRadius: '5px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
            zIndex: 9999
          }}
        >
          {addSuccessMessage}
        </div>
      )}
      <SlidingPanel darkMode={darkMode} show={true} isExpanded={isSidebarExpanded}>
        <div style={{ display: 'flex', height: '100vh' }}>
          <Container darkMode={darkMode} tableisSidebarExpanded={isSidebarExpanded} showRightPanel={showRightPanel || showEditPanel}>
            <HeaderContainer>
              <HeaderLeft>
                <HeaderText>
                  {isEditingHeader ? (
                    <>
                      <input value={headerTitle} onChange={(e) => setHeaderTitle(e.target.value)} />
                      <input value={headerDate} onChange={(e) => setHeaderDate(e.target.value)} />
                      <input value={headerProvince} onChange={(e) => setHeaderProvince(e.target.value)} />
                      <button onClick={saveHeader}>Save</button>
                      <button onClick={() => setIsEditingHeader(false)}>Cancel</button>
                    </>
                  ) : (
                    <>
                      <h2>{headerTitle}</h2>
                      <p>{headerDate}</p>
                      <p>{headerProvince}</p>
                      <button onClick={() => setIsEditingHeader(true)}>Edit</button>
                    </>
                  )}
                </HeaderText>
              </HeaderLeft>
              <RightControls>
                <SearchInput
                  type="text"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <StyledButton onClick={() => setShowRightPanel(true)}>
                  Add NisMasterlist
                </StyledButton>
                <StyledButton onClick={handleExport}>Export</StyledButton>
              </RightControls>
            </HeaderContainer>
            <TableContainer>
              <TableWrapper isExpanded={isSidebarExpanded} id="tableWrapper">
                <div id="scrollContent" style={{ width: '100%', overflowX: 'auto' }}>
                  <Table darkMode={darkMode}>
                    <thead>
                      <tr>
                        <TableHeader darkMode={darkMode}>ACTIONS</TableHeader>
                    <TableHeader darkMode={darkMode}>NO</TableHeader>
                    <TableHeader darkMode={darkMode}>NAME OF SYSTEM</TableHeader>
                    <TableHeader darkMode={darkMode}>TYPE OF SYSTEM</TableHeader>
                    <TableHeader darkMode={darkMode}>NAME OF IA</TableHeader>
                    <TableHeader darkMode={darkMode}>REGION ia</TableHeader>
                    <TableHeader darkMode={darkMode}>PROVINCE ia</TableHeader>
                    <TableHeader darkMode={darkMode}>MUNICIPALITY ia</TableHeader>
                    <TableHeader darkMode={darkMode}>BARANGAY ia</TableHeader>
                    <TableHeader darkMode={darkMode}>LAST NAME</TableHeader>
                    <TableHeader darkMode={darkMode}>FIRST NAME</TableHeader>
                    <TableHeader darkMode={darkMode}>MIDDLE NAME</TableHeader>
                    <TableHeader darkMode={darkMode}>EXTENSION NAME</TableHeader>
                    <TableHeader darkMode={darkMode}>SEX (M/F)</TableHeader>
                    <TableHeader darkMode={darkMode}>BIRTHDAY</TableHeader>
                    <TableHeader darkMode={darkMode}>MOTHERS MAIDEN NAME</TableHeader>
                    <TableHeader darkMode={darkMode}>SPOUSE LASTNAME</TableHeader>
                    <TableHeader darkMode={darkMode}>SPOUSE FIRSTNAME</TableHeader>
                    <TableHeader darkMode={darkMode}>SPOUSE MIDDLENAME</TableHeader>
                    <TableHeader darkMode={darkMode}>SPOUSE EXT NAME</TableHeader>
                    <TableHeader darkMode={darkMode}>REGION</TableHeader>
                    <TableHeader darkMode={darkMode}>PROVINCE</TableHeader>
                    <TableHeader darkMode={darkMode}>MUNICIPALITY</TableHeader>
                    <TableHeader darkMode={darkMode}>BARANGAY</TableHeader>
                    <TableHeader darkMode={darkMode}>HOUSE NUMBER/ STREET/ PUROK</TableHeader>
                    <TableHeader darkMode={darkMode}>REGIONfarm</TableHeader>
                    <TableHeader darkMode={darkMode}>PROVINCEfarm</TableHeader>
                    <TableHeader darkMode={darkMode}>MUNICIPALITYfarm</TableHeader>
                    <TableHeader darkMode={darkMode}>BARANGAYfarm</TableHeader>
                    <TableHeader darkMode={darkMode}>FARM LOT NO.</TableHeader>
                    <TableHeader darkMode={darkMode}>FARM LOT CODE</TableHeader>
                    <TableHeader darkMode={darkMode}>FARM AREA (Ha)</TableHeader>
                    <TableHeader darkMode={darkMode}>TYPE OF OWNERSHIP</TableHeader>
                    <TableHeader darkMode={darkMode}>RSBSA REGISTERED? (Y/N)</TableHeader>
                    <TableHeader darkMode={darkMode}>WITH DA IMC? (Y/N)</TableHeader>
                    <TableHeader darkMode={darkMode}>IF YES, RSBSA REFERENCE NO.? (00-00-00-000-000000)</TableHeader>
                    <TableHeader darkMode={darkMode}>'IF NONE, RSBSA STUB CONTROL NUMBER? (00-00-00-000-000000) /n or type LOST, if RSBSA Enrollment Stub was los</TableHeader>
                    <TableHeader darkMode={darkMode}>WITH NATIONAL ID? (Y/N)</TableHeader>
                    <TableHeader darkMode={darkMode}>IF YES, PHILSYS CARD NUMBER?</TableHeader>
                    <TableHeader darkMode={darkMode}>IF NONE, TRANSACTION SLIP NO.</TableHeader>
                 
                  </tr>
                  
                      <tr>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS colSpan="25" darkMode={darkMode}></TableHeaderS> 
                       
                      </tr>
                    </thead>
                    <tbody>
                      {displayedGroups.map(([is_name, group]) => {
                        let previousIA = null;
                        return (
                          <React.Fragment key={is_name}>
                            <tr>
                              <td
                                colSpan="100%"
                                style={{
                                  backgroundColor: '#cadaba',
                                  fontWeight: 'bold',
                                  textAlign: 'left',
                                  paddingLeft: '10px'
                                }}
                              >
                                {is_name.toUpperCase()}
                              </td>
                            </tr>
                            {group.items.reduce((acc, item, index) => {
                              const showIA = item.ia_name !== previousIA;
                              previousIA = item.ia_name;
                              acc.push(
                                <TableRow
                                  key={`${item.id}-${index}`}
                                  darkMode={darkMode}
                                  onClick={() => handleRowClick(item)}
                                >
                                  <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px', padding: '8px 0' }}>
                                    <ButtonGroup>
                                      <StyledButton onClick={(e) => {
                                        e.stopPropagation();
                                        handleEditData(item);
                                      }}>
                                        ✎
                                      </StyledButton>
                                      <StyledButton onClick={(e) => { e.stopPropagation(); handleDeleteClick(item); }}>❌</StyledButton>
                                    </ButtonGroup>
                                 </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '40px' }}>
                                {index + 1}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'left', minWidth: '240px' }}>
                                {showIA ? (item.system_name || item.is_name) : ''}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'left', minWidth: '200px' }}>
                                {item.system_type}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '200px' }}>
                                {item.ia_name}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'left', minWidth: '200px' }} className="station-mail">
                                {item.ia_region}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'left', minWidth: '200px' }} className="station-iaPres">
                                {item.ia_province}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '200px' }}>
                                {item.ia_municipality}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px' }}>
                                {item.ia_barangay}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px' }} className="station-secNum">
                                {item.lastname}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '80px' }} className="station-secDate">
                                {item.firstname}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px' }} className="station-iaTin">
                                {item.middlename}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '80px' }}>
                                {item.extensionName}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '80px' }}>
                                {item.sex}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.birthday}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '80px' }}>
                                {item.mothers_maidenName}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.spouse_lastname}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.spouse_firstName || item.spouse_firstname}
                              </TableData>
                               <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.spouse_middleName || item.spouse_middlename}
                              </TableData>
                               <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.spouse_extName}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.region}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.province}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.municipality}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.barangay}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.houseNumber}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.regionFarm}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.provinceFarm}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.municipalityFarm}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.barangayFarm}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.farm_lotNum}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.farm_lotCode}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.farmArea}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.ownershipType}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.rsbsa_registered}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.da_imc}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.rsbsa_refNum}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '200px' }}>
                                {item.rsbsa_controlNum}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.national_id}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.philsys_cardNum}
                              </TableData>
                              <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                {item.transactionSlip}
                              </TableData>

                                </TableRow>
                              );
 
                              return acc;
                            }, [])}
               
                          </React.Fragment>
                        );
                      })}
    
                    </tbody>
                  </Table>
                  {shouldShowPagination && (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '12px', marginTop: '12px', flexWrap: 'wrap' }}>
                      <ShowAllButton onClick={handlePreviousPage} disabled={safeCurrentPage === 1}>
                        Previous
                      </ShowAllButton>
                      <span style={{ fontWeight: 'bold' }}>
                        Page {safeCurrentPage} of {totalPages}
                      </span>
                      <ShowAllButton onClick={handleNextPage} disabled={safeCurrentPage === totalPages}>
                        Next
                      </ShowAllButton>
                    </div>
                  )}
                </div>
              </TableWrapper>
              <div
                style={{
                  overflowX: 'auto',
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                }}
                className="hide-scrollbar"
                id="bottomScroll"
              >
                <div style={{ width: '2000px', height: '1px' }} />
              </div>
              {confirmDelete && (
                <DeleteConfirmationModal
                  itemName={confirmDelete.ia_name}
                  onCancel={() => setConfirmDelete(null)}
                  onConfirm={async () => {
                    await deleteNISfsResult(confirmDelete.id);
                    refetch();
                    setConfirmDelete(null);
                  }}
                />
              )}
            </TableContainer>
          </Container>
          <RightPanel darkMode={darkMode} show={showRightPanel || showEditPanel}>
            {showEditPanel && selectedItem && selectedItem.id ? (
              <NisMasterlistAdd
                selectedItem={selectedItem}
                mode="edit"
                year={year}
                presetIaName={iaNameFromState}
                presetIsName={isNameFromState}
                onClose={closeEditPanel}
                darkMode={darkMode}
                onAddSuccess={(msg) => {
                  handleAddSuccess(msg);
                  closeEditPanel();
                }}
              />
            ) : (
              <NisMasterlistAdd
                darkMode={darkMode}
                year={year}
                presetIaName={iaNameFromState}
                presetIsName={isNameFromState}
                onClose={handleClose}
                onAddSuccess={handleAddSuccess}
              />
            )}
          </RightPanel>
        </div>
      </SlidingPanel>
    </>
  );
};

export default NisMasterlist;

// Styled Components
const Container = styled.div`
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#e7f2ec')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  color: ${({ darkMode }) => (darkMode ? '#bdb9b9ff' : '#333')};
  padding: 80px 20px 20px;
  width: ${({ isSidebarExpanded, showRightPanel }) => (showRightPanel ? '57%' : isSidebarExpanded ? 'calc(100% - 100px)' : '98%')};
  min-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  margin-left: ${({ isSidebarExpanded }) => (isSidebarExpanded ? '110px' : '10px')};
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  transition: margin-left 0.3s ease, width 0.3s ease;
  box-sizing: border-box;
`;

const SlidingPanel = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 99%;
  height: 100%;
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#e7f2ec')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  transform: translateX(100%);
  transition: transform 0.5s ease, right 0.3s ease-in-out, width 0.3s ease-in-out;
  z-index: 2;
  padding: 20px;
  box-sizing: border-box;
  overflow-x: hidden;

  ${({ show }) => show && `transform: translateX(0);`}
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0 40px;
`;

const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const HeaderText = styled.div`
  margin-bottom: 10px;
  margin-top: -38px;

  h2 {
    margin: 0;
    font-size: 22px;
    color: ${({ darkMode }) => (darkMode ? '#ffffff' : '#333')};
  }

  p {
    margin: 0;
    font-size: 18px;
    color: ${({ darkMode }) => (darkMode ? '#cccccc' : '#555')};
  }
`;

const RightControls = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-end;
  padding-right: 40px;
`;

const StyledButton = styled.button`
  margin: 0 2px;
  padding: 6px 10px;
  background-color: #eee;
  border: 1px solid #aaa;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 14px;

  &:hover {
    background-color: #ddd;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

const ShowAllButton = styled.button`
  margin: 20px auto;
  display: block;
  padding: 8px 16px;
  background-color: #eee;
  border: 1px solid #aaa;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #ddd;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const BackButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;
  padding-left: 8px;
`;

const BackButton = styled.button`
  padding: 8px 16px;
  background-color: #eee;
  border: 1px solid #aaa;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #ddd;
  }
`;

const SearchInput = styled.input`
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #4caf50;
  border-radius: 4px;
  background-color: #ffffff;
  color: #333;
  font-size: 14px;
  width: 100%;
  transition: border-color 0.2s ease, background-color 0.2s ease;

  &:focus {
    outline: none;
    border-color: #388e3c;
  }

  &:hover {
    background-color: #f1f1f1;
  }

  &::placeholder {
    color: #888;
    font-style: italic;
    font-size: 14px;
  }
`;

const TableWrapper = styled.div`
  width: 100%;
  height: 75vh;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 10px;
  position: relative;
  background-color: ${({ darkMode }) => (darkMode ? 'rgb(42, 48, 42)' : '#f2f2f2')};

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  #scrollContent {
    width: 100%;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  #scrollContent::-webkit-scrollbar {
    display: none;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 2120px;
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  color: ${({ darkMode }) => (darkMode ? '#fff' : '#333')};
`;

const TableHeader = styled.th`
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#2e7d32')};
  color: ${({ darkMode }) => (darkMode ? '#333' : '#fff')};
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ddd;
  text-align: center;
  vertical-align: middle;

  &:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
    background-color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#2e7d32')};
  }

  &[colspan="2"] {
    text-align: center;
    font-weight: bold;
  }
`;

const TableHeaderS = styled.th`
  position: sticky;
  top: 39px;
  z-index: 1;
  background-color: ${({ darkMode }) => (darkMode ? '#1b5e20' : '#4caf50')};
  color: #ffffff;
  padding: 0 10px;
  border: 1px solid #ddd;
  font-size: 12px;
  text-align: center;

  &:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
    background-color: ${({ darkMode }) => (darkMode ? '#1b5e20' : '#4caf50')};
  }
`;

const TableData = styled.td`
  padding: 5px;
  font-size: 12px;
  border: 1px solid #ddd;
  color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#333')};
  transition: background-color 0.3s ease, color 0.3s ease;

  &:first-child {
    position: sticky;
    left: 0;
    background-color: ${({ darkMode }) => (darkMode ? 'rgb(37, 112, 46)' : '#f2f2f2')};
    z-index: 1;
  }

  &.station-mail {
    min-width: 200px;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.station-secNum {
    min-width: 120px;
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.station-secDate {
    min-width: 80px;
    max-width: 80px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.station-iaTin {
    min-width: 120px;
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.station-iaPres {
    min-width: 200px;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const TableRow = styled.tr`
  background: ${({ darkMode }) => (darkMode ? 'rgba(3, 82, 33, 0.3)' : '#fff')};
  backdrop-filter: ${({ darkMode }) => (darkMode ? 'blur(10px)' : 'none')};
  -webkit-backdrop-filter: ${({ darkMode }) => (darkMode ? 'blur(10px)' : 'none')};

  &:hover {
    background-color: ${({ darkMode }) => (darkMode ? 'rgb(37, 112, 46)' : '#f1f1f1')};
    color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#333')};
  }

  &:hover td {
    background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
    color: ${({ darkMode }) => (darkMode ? '#fff' : '#333')};
  }

  &:nth-child(even) {
    background-color: ${({ darkMode }) => (darkMode ? 'rgba(3, 82, 33, 0.3)' : '#f9f9f9')};
  }
`;

const RightPanel = styled.div`
  position: fixed;
  top: 0;
  right: ${({ show }) => (show ? '0' : '-45%')};
  width: 43%;
  height: 100%;
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#fff')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  z-index: 5;
  padding: 5px;
  box-sizing: border-box;
  transition: right 0.3s ease-in-out;
`;

const TableContainer = styled.div`
  margin-top: 0;
  padding: 0 20px;
  overflow-x: hidden;
`;